import React, { createContext, useContext, useState } from 'react'

interface MedicationUpdateContextType {
  isUpdating: boolean
  setUpdating: (state: boolean) => void
}

const MedicationUpdateContext = createContext<
  MedicationUpdateContextType | undefined
>(undefined)

// テスト用のPropsインターフェース
interface MedicationUpdateProviderProps {
  children: React.ReactNode
  // テスト用: 初期状態を外部から設定可能にする
  initialUpdatingState?: boolean
  // テスト用: 状態変更を外部から監視可能にする
  onUpdatingStateChange?: (state: boolean) => void
}

export const MedicationUpdateProvider: React.FC<
  MedicationUpdateProviderProps
> = ({ children, initialUpdatingState = false, onUpdatingStateChange }) => {
  const [isUpdating, setIsUpdatingInternal] = useState(initialUpdatingState)

  const setUpdating = (state: boolean) => {
    setIsUpdatingInternal(state)
    // テスト用のコールバックを呼び出し
    if (onUpdatingStateChange) {
      onUpdatingStateChange(state)
    }
  }

  return (
    <MedicationUpdateContext.Provider value={{ isUpdating, setUpdating }}>
      {children}
    </MedicationUpdateContext.Provider>
  )
}

export const useMedicationUpdate = (): MedicationUpdateContextType => {
  const context = useContext(MedicationUpdateContext)
  if (!context) {
    throw new Error(
      'useMedicationUpdate must be used within a MedicationUpdateProvider'
    )
  }
  return context
}

// テスト用のヘルパー: Contextの値を直接取得
export const MedicationUpdateContextForTest = MedicationUpdateContext
